import { render, staticRenderFns } from "./listActivity.vue?vue&type=template&id=6fd1212a&"
import script from "./listActivity.vue?vue&type=script&lang=js&"
export * from "./listActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports